import { z } from 'zod';

import { BallMover, ScriptKey } from './asset.enums.ts';
import { StepType, TaskType } from './asset.enums.ts';

// Lesson schemas
export const LessonStepSchema = z.object({
  stepType: z.nativeEnum(StepType),
  index: z.number().optional(),
  subindex: z.number().optional(),
  scriptKey: z.nativeEnum(ScriptKey).optional(),
  question: z.string().optional(),
  answer: z.string().optional(),
  parts: z.array(z.string()).optional(),
  content: z.string().optional(),
  quickSlide: z.boolean().optional(),
  ballMover: z.nativeEnum(BallMover).optional().default(BallMover.App),
  hidePicture: z.boolean().optional(),
  startIndex: z.number().optional(),
  transitionIndex: z.number().optional(),
  target: z.string().optional(),
});

export const LessonTaskDisplayOptionsSchema = z.object({
  hideLengthIndicators: z.boolean().optional(),
  hideSpaces: z.boolean().optional(),
  hideArrowStart: z.boolean().optional(),
  showRegularWords: z.boolean().optional(),
  showSilentLetterAsRegular: z.boolean().optional(),
  useSerifFont: z.boolean().optional(),
  hasTitle: z.boolean().optional(),
  onlyCapitals: z.boolean().optional(),
});

export const LessonTaskSchema = LessonTaskDisplayOptionsSchema.extend({
  taskType: z.nativeEnum(TaskType),
  letters: z.array(z.string()).optional(),
  words: z.array(z.string()).optional(),
  story: z.array(z.array(z.string())).optional(),
  rhymingSounds: z.array(z.string()).optional(),
  picture: z.string().optional(),
  steps: z.array(LessonStepSchema),
});

export const LessonSchema = z.object({
  lessonTitle: z.string(),
  animalCharacterKey: z.string(),
  tasks: z.array(LessonTaskSchema),
});

export type LessonTaskDisplayOptions = z.infer<typeof LessonTaskDisplayOptionsSchema>;
export type LessonStep = z.infer<typeof LessonStepSchema>;
export type LessonTask = z.infer<typeof LessonTaskSchema>;
export type Lesson = z.infer<typeof LessonSchema>;

export interface LessonKey {
  lesson: number;
}
export interface LessonTaskKey extends LessonKey {
  task: number;
}
export interface LessonTaskStepKey extends LessonTaskKey {
  step: number;
}

export interface LessonTaskWithLesson {
  lesson: Lesson;
  task: LessonTask;
}

export interface LessonTaskStepWithLessonAndTask extends LessonTaskWithLesson {
  step: LessonStep;
}

export enum LessonTaskPictureExtension {
  Jpg = 'jpg',
}
